/**
 * Product mockup used in the hero and the pricing card.
 * If the image can't load, ProductVisual falls back to a code-drawn cover in the product identity.
 */
export const driveImage = (id: string, width = 1600) => `https://lh3.googleusercontent.com/d/${id}=w${width}`

export const PRODUCT_MOCKUP =
  'https://cdn.magicpatterns.com/uploads/14Ynfqqe6dXf7NU7SMjfQW/Photorealistic-commercial-product-mockup.png'

export const PRODUCT_MOCKUP_ALT =
  'The six Aerial Class Ready volumes — The Flight Path System, Silks, Hoop, Trapeze, Intermediate & Combinations, and Choreography & Showcase — standing in a bright aerial studio with silks, a lyra and a trapeze'

export const PRODUCT_NAME = 'Aerial Class Ready'

/** Where the pricing button sends the instructor (ImpulTienda checkout). */
export const CHECKOUT_URL = 'https://aerial-class-ready.impultienda.ar/checkout'
